import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ExcursionItinerary } from 'src/app/shared/models/excursion-itineraries.interface';

@Component({
	selector: 'app-travel-board-quick',
	templateUrl: './travel-board-quick.component.html'
})
export class TravelBoardQuickComponent implements OnInit {

	//public cancel: EventEmitter<any> = new EventEmitter<any>();
	public selectBoard: EventEmitter<any> = new EventEmitter<any>();
	public createBoard: EventEmitter<any> = new EventEmitter<any>();
	public chooseBoard: EventEmitter<any> = new EventEmitter<any>();

	public productId: string;
	public currentBoard: ExcursionItinerary;

	constructor(
		public modalService: BsModalService,
		private modalRef: BsModalRef
	) { }

	ngOnInit(): void {
		// console.log('TravelBoardQuickComponent.productId:', this.productId);
		//console.log('TravelBoardQuickComponent.currentBoard:', this.currentBoard);
	}


	public closeModal() {
		//this.cancel.emit();
		this.modalRef?.hide();
	}

	public onSelectBoard() {
		this.selectBoard.emit({productId: this.productId, board: this.currentBoard});
		this.modalRef?.hide();
	}

	public onChooseBoard() {
		this.chooseBoard.emit({productId: this.productId});
		this.modalRef?.hide();
	}

	public onCreateBoard() {
		this.createBoard.emit({productId: this.productId});
		this.modalRef?.hide();
	}

}
